import React from "react";
import { Row, Col, Container, Card } from "reactstrap";
import "./CSS/StationWiseData.css";

const MachineDetails = (props) => {
  let machineCardDetails = props.machineCardDetails;
  return (
    <Row className="d-flex flex">
      <Col>
        <Container fluid className="justify-content-center align-items-center ">
          <Card
            className="p-2 info_widget "
            style={{
              boxShadow: "1.5px 4px 6px 0px rgba(44, 46, 52, 0.20)",
              borderRadius: "8px",
            }}
          >
            <Row className="Color value_display align_value ">
               <span>
                Model:{" "}
                <strong className="font-size-xs">
                  {machineCardDetails?.model}
                </strong> 
              &nbsp; &nbsp; 
                BIN:{" "}
                <strong className="font-size-xs">
                  {machineCardDetails?.bin}
                </strong>
                &nbsp; &nbsp;
                Date:{" "}
                <strong className="font-size-xs">
                  {machineCardDetails?.date}
                </strong>
                &nbsp; &nbsp;
                Shift:{" "}
                <strong className="font-size-xs">
                  {machineCardDetails?.shift}
                </strong>
               &nbsp; &nbsp;
                Scan Time:{" "}
                <strong className="font-size-xs">
                  {machineCardDetails?.time}
                </strong>
              </span>

              {/* </Col> */}
            </Row>
          </Card>
        </Container>
      </Col>
    </Row>
  );
};

export default MachineDetails;
